/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PunchDetailMainViewModel } from './punchDetailMainViewModel';
import { PunchLogViewModel } from './punchLogViewModel';
import { PunchMediaViewModel } from './punchMediaViewModel';
import { PunchRemarkViewModel } from './punchRemarkViewModel';

export interface PunchDetailByTabsViewModel { 
    mainAndSignatures?: PunchDetailMainViewModel;
    attachments?: Array<PunchMediaViewModel>;
    remarks?: Array<PunchRemarkViewModel>;
    timeline?: Array<PunchLogViewModel>;
}